import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseActivityEntity } from './activity-history/base-activity.entity';
import type { ClientLicenseEntity } from './client-license.entity';

@Index('idx_la_license_created', ['fkLicenseId', 'createdDate'], {})
@Index('idx_la_type', ['activityType'], {})
@Index('idx_la_user', ['fkUserId'], {})
@Entity('license_activity')
export class LicenseActivityEntity extends BaseActivityEntity {
	@Column('int', { name: '_fk_license__id', unsigned: true })
	public fkLicenseId!: number;

	@ManyToOne('ClientLicenseEntity', 'activities', {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_license__id', referencedColumnName: 'id' }])
	public fkLicense!: ClientLicenseEntity;
}
